if (!customElements.get("featured-pinned-products")) {
  class FeaturedPinnedProducts extends HTMLElement {
    connectedCallback() {
      this.swiperContainer = this.querySelector(".swiper-container");
      this.slides = this.querySelectorAll(".swiper-slide");
      this.featurePanels = this.querySelectorAll("[data-feature-index]");
      this.mobileHeading = this.querySelector("[data-mobile-heading-output]");
      this.mobileLink = this.querySelector("[data-mobile-link]");
      this.nextLabel = this.querySelector("[data-next-label-output]");
      this.total = parseInt(this.dataset.total, 10) || 0;

      if (!this.swiperContainer || this.total < 1) return;

      this.bindCarousel(0);
    }

    bindCarousel(attempt) {
      const swiper = this.swiperContainer.swiper;

      if (!swiper) {
        if (attempt < 40) {
          window.setTimeout(() => this.bindCarousel(attempt + 1), 50);
        }
        return;
      }

      const update = () => {
        const index = swiper.realIndex || swiper.activeIndex || 0;
        this.updateFeaturePanel(index);
        this.updateSlideContent(index);
      };

      update();
      swiper.on("slideChange", update);
    }

    updateFeaturePanel(index) {
      this.featurePanels.forEach((panel) => {
        const isActive = parseInt(panel.dataset.featureIndex, 10) === index;

        panel.classList.toggle("is-active", isActive);

        if (panel.tagName === "A") {
          panel.setAttribute("tabindex", isActive ? "0" : "-1");
        }
      });
    }

    updateSlideContent(index) {
      const slide = this.slides[index];

      if (!slide) return;

      this.slides.forEach((item, itemIndex) => {
        item.setAttribute("aria-current", itemIndex === index ? "true" : "false");
      });

      if (this.mobileHeading && slide.dataset.mobileHeading) {
        this.mobileHeading.innerHTML = slide.dataset.mobileHeading;
      }

      if (this.mobileLink) {
        this.mobileLink.textContent = slide.dataset.mobileLinkLabel || "";

        if (slide.dataset.mobileLinkUrl) {
          this.mobileLink.href = slide.dataset.mobileLinkUrl;
          this.mobileLink.removeAttribute("aria-disabled");
        } else {
          this.mobileLink.removeAttribute("href");
          this.mobileLink.setAttribute("aria-disabled", "true");
        }
      }

      if (this.nextLabel) {
        this.nextLabel.textContent = slide.dataset.nextLabel || "";
      }
    }
  }

  customElements.define("featured-pinned-products", FeaturedPinnedProducts);
}
